import React, { useEffect, useState } from 'react';
import { FALLBACK_IMAGE_SRC } from '../utils/placeholderImage';

const CourseHeroImage = ({ src, alt = '', fallbackSrc = FALLBACK_IMAGE_SRC, className = '', style = {} }) => {
  const [effectiveUrl, setEffectiveUrl] = useState(src || fallbackSrc);

  useEffect(() => {
    let cancelled = false;
    const url = src || fallbackSrc;
    setEffectiveUrl(url);
    if (!url || url === fallbackSrc) return;
    const img = new Image();
    img.onload = () => {
      if (!cancelled) setEffectiveUrl(url);
    };
    img.onerror = () => {
      if (!cancelled) setEffectiveUrl(fallbackSrc);
    };
    img.src = url;
    return () => {
      cancelled = true;
      img.onload = null;
      img.onerror = null;
    };
  }, [src, fallbackSrc]);

  return (
    <div
      role="img"
      aria-label={alt}
      draggable="false"
      onContextMenu={(e) => e.preventDefault()}
      className={`ui-integrated-image ${className}`.trim()}
      style={{
        backgroundImage: `url(${effectiveUrl})`,
        backgroundSize: 'contain',
        backgroundColor: '#f1f5f9',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        ...style,
      }}
    />
  );
};

export default CourseHeroImage;
